import { sceneBuilder } from '@studio/program/sceneBuilder/sceneBuilder';
import { isPresenterBannerLayerSource } from '@studio/program/utils/scene';
import { BROADCAST_SET_PROGRAM } from 'actions/Types';
import * as SceneLayouts from 'constants/SceneLayouts';
/**
  Before program is updated in api with the scene from scene builder,
  the payload is sanitized and all banner markups are stripped off,
  they’re then mapped back in api before the program is saved in database.
  This middleware `Intercepts` this response, reconstructs it to make sure banners regenerated.
  This will only rebuild the scene if presenter banner is in current program.
  @param {{
  getState : Function
  }} store
 */
function programPresenterBannersUpdater(store) {
  return next => {
    return async action => {
      const targetActions = [`${BROADCAST_SET_PROGRAM}_SUCCESS`];

      if (targetActions.includes(action.type)) {
        const {
          banners,
          sceneLayers,
          broadcastSources: { sources },
          brandingSettings
        } = store.getState();

        const { payload: broadcast } = action;

        const { program } = broadcast;

        const { layers } = program;

        const layerSources = [...sceneLayers, ...banners];

        const sceneLayout = SceneLayouts[program._id];

        /**
         * If there is no presenter banner in program,
         * just return the current program without rebuilding the scene.
         */
        const presenterBannerInProgram = layers?.find(layer => {
          return isPresenterBannerLayerSource(layer?.source?.value);
        });

        if (!presenterBannerInProgram) {
          return next(action);
        }

        // Reconstruct the scene to make sure banners are regenerated
        const scene = sceneBuilder(
          sceneLayout,
          sources,
          layerSources,
          {},
          {},
          brandingSettings?.fonts
        );

        const updatedBroadcast = {
          ...broadcast,
          program: scene
        };

        // Intercept broadcast before it's set in state.
        return next({
          ...action,
          payload: updatedBroadcast
        });
      }

      return next(action);
    };
  };
}

export default programPresenterBannersUpdater;
